import { Box } from "@mui/material";
import BillingComponent from "../../components/account/billing";
function BillingPage() {
  return <Box>{<BillingComponent />}</Box>;
}

export default BillingPage;
